import './GroupList.component.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { ERoutes } from '../../../assets/constants/routes';
import { EGroupStateKeys, IGroupResume } from '../../../domain/group.interface';
import { ENotification } from '../../../domain/notification.interface';
import { deleteGroup, loadGroupList, resetGroup } from '../../../store/grouplist/grouplist.actions';
import { makeSelectGroupList } from '../../../store/grouplist/grouplist.selectors';
import { returnNotification } from '../../../store/render-controller/render-controller.actions';
import { replacePathParams } from '../../../utils/NavigateWithParams';
import { ItemListComponent } from '../../atoms/atoms.index';
import { EItemList } from '../../atoms/itemList/ItemList.component';
import { NavbarComponent, NavigationMenuComponent } from '../../organisms/organisms.index';

export function GroupListComponent(props: any) {
  const dispatch = useDispatch();
  const groupListReducer: IGroupResume[] = useSelector(makeSelectGroupList());
  const [groupList, setGroupList] = useState(groupListReducer);

  useEffect(() => {
    dispatch(loadGroupList());
    return () => {
      dispatch(resetGroup(EGroupStateKeys.groupList));
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setGroupList(groupListReducer);
  }, [groupListReducer]);

  const checkDelete = (
    isCurrentUserAdmin: boolean,
    paid: boolean,
    wishPurchased: boolean,
    hasPendingPayments: boolean,
  ) => {
    const check =
      isCurrentUserAdmin ||
      !hasPendingPayments ||
      (hasPendingPayments && !paid) ||
      (paid && wishPurchased);
    return check;
  };

  const checkEdit = (isCurrentUserAdmin: boolean) => {
    const check = isCurrentUserAdmin;
    return check;
  };

  const deleteFunction = (
    id: string,
    isCurrentUserAdmin: boolean,
    checkPayment: boolean,
  ) => {
    dispatch(
      returnNotification({
        type: ENotification.WARNING,
        msg1: isCurrentUserAdmin
          ? 'warning.delete.group'
          : checkPayment
          ? 'warning.has-payment'
          : 'warning.confirmation.message',
        dispatch: { func: deleteGroup, param: [id] },
      }),
    );
  };
  const editFunction = (id: string) => {
    props.history.push('editgroup/' + id);
  };

  return (
    <div className='grouplist-container fluid-container page-container'>
      <div>
        <NavbarComponent />
        <NavigationMenuComponent {...props} />
      </div>
      <div className='content-wrapper'>
        <div className='title-container'>
          <Link to={ERoutes.NEW_GROUP}>
            <button className='add-btn mb-2'>
              <FontAwesomeIcon icon='plus-circle' />{' '}
              <FormattedMessage id='pages.groups.add_group'></FormattedMessage>
            </button>
          </Link>
        </div>
        <section className='itemlist-container'>
          <ul className='itemlist d-flex flex-wrap justify-content-between align-items-center'>
            {groupList &&
              groupList.map((group: IGroupResume) => {
                const {
                  id,
                  name,
                  isCurrentUserAdmin,
                  wishPurchased,
                  hasPendingPayments,
                  paid,
                  photoUrl,
                } = group;

                return (
                  <Link
                    to={replacePathParams(ERoutes.GROUP, { groupId: id })}
                    key={id}
                  >
                    <ItemListComponent
                      name={name}
                      type={EItemList.GROUP}
                      highlight={isCurrentUserAdmin}
                      photoUrl={photoUrl}
                      deleteFunction={
                        checkDelete(
                          isCurrentUserAdmin,
                          paid,
                          !!wishPurchased,
                          hasPendingPayments,
                        )
                          ? (e: any) => {
                              e.preventDefault();
                              const checkPayment = hasPendingPayments && !paid;
                              deleteFunction(
                                id as string,
                                isCurrentUserAdmin,
                                checkPayment,
                              );
                            }
                          : null
                      }
                      editFunction={
                        checkEdit(isCurrentUserAdmin)
                          ? (e: any) => {
                              e.preventDefault();
                              editFunction(id as string);
                            }
                          : null
                      }
                    />
                  </Link>
                );
              })}
          </ul>
        </section>
      </div>
    </div>
  );
}
